import React, { useEffect, useState } from "react";
import "./team-admin.css";
import TeamForm from "./TeamForm";
import TeamCard from "./TeamCard";
import { apiGet, apiDel } from "../../admin/api";

export default function TeamList() {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(false);

  const limit = 12;

  const load = async () => {
    setLoading(true);
    try {
      const data = await apiGet(`/api/team?page=${page}&limit=${limit}`);
      setItems(Array.isArray(data.items) ? data.items : []);
    } catch (e) {
      alert(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const onDelete = async (id) => {
    if (!window.confirm("Remove this member?")) return;
    try {
      await apiDel(`/api/team/${id}`);
      load();
    } catch (err) {
      alert(err.message);
    }
  };

  const openCreate = () => {
    setEditing(null);
    setShowForm(true);
  };
  const closeForm = () => {
    setShowForm(false);
    setEditing(null);
  };

  const showPager = page > 1 || (items?.length || 0) === limit;

  return (
    <div className="team-admin">
      <div className="toolbar">
        <h2 className="toolbar__title">Team Members</h2>
        <div className="toolbar__actions">
          <button className="btn btn--cta" onClick={openCreate} title="Add Team Member">
            <span className="i i-plus" aria-hidden="true" />
            Add Member
          </button>
        </div>
      </div>

      {showForm ? (
        <div className="panel">
          <div className="panel__head">
            <h3 className="panel__title">{editing ? "Edit Member" : "Add Member"}</h3>
          </div>
          <TeamForm
            initial={editing}
            onSaved={() => { closeForm(); load(); }}
            onCancel={closeForm}
          />
        </div>
      ) : (
        <>
          {loading ? (
            <div className="empty">Loading…</div>
          ) : items.length === 0 ? (
            <div className="empty">
              <div className="empty__icon">👥</div>
              <div className="empty__title">No team members</div>
              <div className="empty__desc">Click the button to add your first member.</div>
              <button className="btn btn--cta" onClick={openCreate}>
                <span className="i i-plus" /> Add member
              </button>
            </div>
          ) : (
            <div className="grid">
              {items.map((it) => (
                <TeamCard
                  key={it.id}
                  item={it}
                  onEdit={(m) => { setEditing(m); setShowForm(true); }}
                  onDelete={onDelete}
                />
              ))}
            </div>
          )}

          {showPager && (
            <div className="pager">
              <button
                className="pill"
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                <span className="i i-left" aria-hidden="true" />
                Prev
              </button>

              <span className="badge">Page {page}</span>

              <button className="pill" onClick={() => setPage((p) => p + 1)}>
                Next
                <span className="i i-right" aria-hidden="true" />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
